import { SchoolSoftScheduleSelectedEmail, SchoolSoftScheduleEventNaming} from '../../../../../../models/CoreSchoolSoftScheduleConfigurationModels';


export const selectedEmails: SchoolSoftScheduleSelectedEmail[] = [
    SchoolSoftScheduleSelectedEmail.Email,
    SchoolSoftScheduleSelectedEmail.TeamsAccount,
    SchoolSoftScheduleSelectedEmail.ClassroomAccount,
]

export const scheduleEventNaming : SchoolSoftScheduleEventNaming[] = [
    SchoolSoftScheduleEventNaming.Subject,
    SchoolSoftScheduleEventNaming.Group,
    SchoolSoftScheduleEventNaming.GroupWithSubject,
    SchoolSoftScheduleEventNaming.SubjectWithGroup,
]
